import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLoaderData, useLocation, useNavigate } from '@remix-run/react';
import LosseLink from './LosseLink';
export default function LosseKruumels({ crumbs = [], type = 'path', preCrumbs = [{ title: 'Home', uri: '/' }], seperator = _jsx("span", { children: "\u00A0/\u00A0" }), ...rest }) {
    if (type === 'history')
        return _jsx(KruumelsFromHistory, { ...rest, preCrumbs: preCrumbs, seperator: seperator });
    if (type === 'custom')
        return _jsx(KruumelsFromCustom, { ...rest, crumbs: crumbs, seperator: seperator });
    if (type === 'fragment')
        return _jsx(KruumelsFromFragment, { ...rest, preCrumbs: preCrumbs, seperator: seperator });
    return _jsx(KruumelsFromPath, { ...rest, preCrumbs: preCrumbs, seperator: seperator });
}
function KruumelsFromFragment({ className, classNameCrumb, preCrumbs, seperator }) {
    const { page } = useLoaderData();
    const parent = page === null || page === void 0 ? void 0 : page.parent;
    return (_jsx("nav", { className: className !== null && className !== void 0 ? className : undefined, children: _jsxs("ol", { "aria-label": "Breadcrumbs", children: [preCrumbs &&
                    preCrumbs.map((crumb, index) => (_jsx(Breadcrumb, { crumb: crumb, className: classNameCrumb, seperator: index === 0 ? undefined : seperator }, crumb.uri))), parent && _jsx(KruumelsFromFragmentParent, { parent: parent, classNameCrumb: classNameCrumb, seperator: seperator }), _jsx(Breadcrumb, { crumb: page, className: classNameCrumb, seperator: seperator })] }) }));
}
function KruumelsFromFragmentParent({ parent, classNameCrumb, seperator }) {
    return (_jsxs(_Fragment, { children: [parent.node.parent && _jsx(KruumelsFromFragmentParent, { parent: parent.node.parent, seperator: seperator }), _jsx(Breadcrumb, { crumb: parent.node, className: classNameCrumb, seperator: seperator })] }));
}
function KruumelsFromPath({ className, classNameCrumb, preCrumbs, seperator }) {
    const { pathname } = useLocation();
    const uris = pathname.split('/').filter((path) => path);
    const crumbs = [];
    if (preCrumbs) {
        preCrumbs.forEach((crumb) => crumbs.push(crumb));
    }
    uris.forEach((uri, uriIndex) => {
        crumbs.push({
            title: uri.replace(/-/g, ' '),
            uri: `/${uris.slice(0, uriIndex + 1).join('/')}/`
        });
    });
    return (_jsx("nav", { className: className !== null && className !== void 0 ? className : undefined, children: _jsx("ol", { "aria-label": "Breadcrumbs", children: crumbs.map((crumb, index) => (_jsx(Breadcrumb, { crumb: crumb, className: classNameCrumb, seperator: index === 0 ? undefined : seperator }, crumb.uri))) }) }));
}
function KruumelsFromHistory({ className, seperator }) {
    const navigate = useNavigate();
    return (_jsx("nav", { className: className !== null && className !== void 0 ? className : undefined, children: _jsxs("div", { className: "losse-kruumel-history", onClick: () => {
                if (document.referrer === '') {
                    navigate('/');
                }
                else {
                    navigate(-1);
                }
            }, children: [seperator, "Terug"] }) }));
}
function KruumelsFromCustom({ className, classNameCrumb, crumbs, seperator }) {
    return (_jsx("nav", { className: className !== null && className !== void 0 ? className : undefined, children: _jsx("ol", { "aria-label": "Breadcrumbs", children: crumbs &&
                crumbs.map((crumb, index) => (_jsx(Breadcrumb, { crumb: crumb, className: classNameCrumb, seperator: index === 0 ? undefined : seperator }, crumb.uri))) }) }));
}
function Breadcrumb({ crumb, className, seperator }) {
    return (_jsxs("li", { className: className !== null && className !== void 0 ? className : undefined, children: [seperator, _jsx(LosseLink, { to: crumb.uri, children: crumb.title })] }, crumb.uri));
}
export const losseKruumelsFragment = `
  title
  uri
  ... on Page {
    parent {
      node {
        uri
        ... on Page {
          title
          parent {
            node {
              uri
              ... on Page {
                title
                parent {
                  node {
                    uri
                    ... on Page {
                      title
                      parent {
                        node {
                          uri
                          ... on Page {
                            title
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
